import axios from 'axios';

import { ItemInventoryBalance, ItemInventory } from './types';

const inventoryApi = axios.create({
  baseURL: process.env.INVENTORY_MANAGEMENT_URI,
});

export default inventoryApi;

export const getVenueInventory = (venueId: string): Promise<ItemInventory[]> =>
  inventoryApi
    .get<{ itemStockInfos: ItemInventory[] }>(`/v1/venue-inventories/${venueId}`)
    .then(response => response.data.itemStockInfos);

export const updateVenueInventory = (venueId: string, itemId: string, balance: number): Promise<boolean> =>
  inventoryApi
    .put(`/v1/venue-inventories/${venueId}/adjust`, {
      itemId,
      balance,
    })
    .then(response => response.status === 200);

export const updateVenueInventories = (venueId: string, balances: ItemInventoryBalance[]): Promise<boolean> =>
  inventoryApi
    .put(`/v1/venue-inventories/${venueId}/batch-override`, {
      balanceOverrides: balances,
    })
    .then(response => response.status === 200);
